var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6668 16L27.4135 12.28L27.8668 7.36L23.0535 6.26667L20.5335 2L16.0002 3.94667L11.4668 2L8.94683 6.25333L4.1335 7.33333L4.58683 12.2667L1.3335 16L4.58683 19.72L4.1335 24.6533L8.94683 25.7467L11.4668 30L16.0002 28.04L20.5335 29.9867L23.0535 25.7333L27.8668 24.64L27.4135 19.72L30.6668 16ZM12.5068 21.3467L9.3335 18.1467C8.8135 17.6267 8.8135 16.7867 9.3335 16.2667L9.42683 16.1733C9.94683 15.6533 10.8002 15.6533 11.3202 16.1733L13.4668 18.3333L20.3335 11.4533C20.8535 10.9333 21.7068 10.9333 22.2268 11.4533L22.3202 11.5467C22.8402 12.0667 22.8402 12.9067 22.3202 13.4267L14.4268 21.3467C13.8802 21.8667 13.0402 21.8667 12.5068 21.3467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.706b350f7b540b5b049759b936881884.svg";
export { ForwardRef as ReactComponent };